import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'website',
  noIndex = false 
}) => {
  const siteName = 'Bravo Producciones';
  const defaultDescription = 'Productora de eventos líder en Argentina. Fiestas exclusivas, música electrónica y experiencias únicas.';
  const defaultImage = 'https://customer-assets.emergentagent.com/job_admin-panel-v2/artifacts/mtlhf8v0_Blanco-Negro-Horizontal.jpg';
  const baseUrl = 'https://bravoproductora.com';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Eventos & Entretenimiento`;
  const finalDescription = description || defaultDescription;
  const finalImage = image || defaultImage;
  const finalUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / WhatsApp / Facebook */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="es_AR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={finalUrl} />
    </Helmet>
  );
};

export default SEO;
